export default __webpack_public_path__ + "static/media/component-177-2@3x.0c8d8740.png";